export default {
  rfi: {
    pages: {
      search: {
        header: {
          title: 'Solicitudes de Información',
        },
        body: {
          filters: {
            placeholders: {
              search: 'Buscar por ID Solicitud, Descripción de Solicitud, Descripción del Item Solicitado',
            },
          },
          actions: {
            search: 'Buscar',
            see_rfi: 'Ver Solicitud',
          },
          table: {
            statuses: {
              published: 'Publicada',
              closed: 'Cerrada',
            },
            responses: {
              without_responding: 'Sin Responder',
              answered: 'Respondida',
            },
            columns: {
              id: 'ID Solicitud',
              name: 'Nombre',
              created_at: 'Fecha de creación',
              close_date: 'Fecha de cierre',
              status: 'Estado de la solicitud',
              user: 'Usuario',
              buyer: 'Comprador',
              keyword: 'Palabra buscada',
              item: 'Ítem',
              sku: 'Sku',
              price: 'Precio',
              code: 'Código',
              category: 'Categoría',
              search_type: 'Tipo de búsqueda',
            },
          },
        },
      },
      request: {
        header: {
          title: 'Solicitud de Información',
        },
        body: {
          filters: {
            placeholders: {
              search: 'Buscar por ID Solicitud, Descripción de Solicitud, Descripción del Item Solicitado',
            },
          },
          actions: {
            search: 'Buscar',
            save: 'Guardar',
            reply: 'Responder Solicitud',
            voucher: 'Comprobante de Respuesta',
          },
          entity: {
            statuses: {
              published: 'Publicada',
              closed: 'Cerrada',
            },
            responses: {
              without_responding: 'Sin Respuesta',
              answered: 'Respondida',
            },
            buyer: 'Comprador',
            description_search: 'Descripción de Búsqueda',
            number: 'N° Solicitud',
            status: 'Estado solicitud',
            request: 'Solicitud',
            response: 'Estado Respuesta',
            name: 'Nombre Solicitud',
            notes: 'Notas',
            response_deadline: 'Fecha Límite de Respuesta',
            attachment: 'Adjunto',
            see_attachment: 'Ver adjunto',
            reply_request: 'Responder Solicitud',
            yes: 'Si',
            no: 'No',
            attachments: {
              title: 'Adjuntos',
              placeholder: 'Agregue adjunto para este ítem (opcional)',
              change_attachment: 'Cambiar adjuntos',
              response: 'Respuesta',
            },
            items_match: {
              title: 'Ítems de su catálogo coincidentes con la Descripción de Búsqueda',
              selected_item: 'Ítem seleccionado',
              description: 'Descripción',
              price: 'Precio',
              currency: 'Moneda',
              offer: {
                title: 'Ingrese oferta de precio para este ítem (opcional)',
              },
            },
            stock: {
              title: 'Confirmación de stock',
              requested_amount: 'Cantidad Solicitada',
              requested_uom: 'Unidad de Medida Solicitada',
              do_you_have: '¿Dispone de la cantidad de unidades de medida solicitadas?',
              alternative_available: 'Ingresar alternativa de Stock Disponible',
              quantity_available: 'Cantidad Disponible',
              uom_available: 'Unidad de Medida Disponbile',
            },
            delivery: {
              title: 'Disponibilidad de entrega',
              delivery_date: 'Fecha de Entrega',
              place_of_delivery: 'Lugar de Entrega',
              do_you_have: '¿Dispone de factibilidad de entrega para la fecha y lugar indicados?',
              alternative: 'Ingresar alternativa de Disponibilidad de Entrega',
            },
            technical: {
              title: 'Aclaraciones Técnicas',
              specifications: 'Especificaciones Técnicas',
              response: 'Respuesta',
              guarantee: 'Garantía y Calidad',
              use: 'Acerca del uso',
              origin: 'Origen y Fabricación',
              additional: 'Información Adicional',
            },
            observations: 'Observaciones',
            created_at: 'Fecha de creación',
            item: 'Ítem',
            sku: 'Sku',
            price: 'Precio',
            code: 'Código',
            category: 'Categoría',
            search_type: 'Tipo de búsqueda',
          },
        },
      },
      resumen: {
        title: 'Resumen de la respuesta',
        messages: {
          note: 'Guardaremos su solicitud antes de ser enviada',
          rule: 'Solo se considerarán los ítems validados',
        },
        actions: {
          reply: 'Enviar Respuesta',
        },
        entity: {
          validated_items: 'Ítems validados',
          not_validated_items: 'Ítems sin validar',
          observations: 'Observaciones generales',
        },
      },
      voucher: {
        title: 'Comprobante de la respuesta',
        messages: {
          note: 'Información de envío',
        },
        actions: {
          reply: 'Enviar Respuesta',
        },
        entity: {
          shipping_date: 'Fecha de Envío',
          sent_by: 'Enviado por',
          items_answered: 'Ítems respondidos',
          observations: 'Observaciones generales',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/rfi.js